import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Drawer } from "@/components/ui/drawer";
import { useEtrDocuments } from "@/features/etr-documents/hooks/use-etr-documents";
import { CreateEtrForm } from "@/features/etr-documents/components/create-etr-form";
import { EtrDocumentList } from "@/features/etr-documents/components/etr-document-list";
import type { ChildOutletContext } from "./child-detail-page";

export function ChildEtrsTab() {
  const { t } = useTranslation("etr-documents");
  const { child, childId } = useOutletContext<ChildOutletContext>();
  const [showCreateEtr, setShowCreateEtr] = useState(false);
  const {
    etrs,
    isLoading: etrsLoading,
    reload: reloadEtrs,
  } = useEtrDocuments(childId);
  const isViewer = child.role === "viewer";

  return (
    <Card data-testid="etr-documents-section">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-serif">{t("childTab.heading")}</h2>
        {!isViewer && (
          <Button
            variant="secondary"
            onClick={() => setShowCreateEtr(true)}
            data-testid="new-etr-button"
          >
            {t("childTab.newButton")}
          </Button>
        )}
      </div>
      <EtrDocumentList
        etrs={etrs}
        isLoading={etrsLoading}
        onDeleted={reloadEtrs}
      />

      <Drawer
        open={showCreateEtr}
        onClose={() => setShowCreateEtr(false)}
        title={t("childTab.newDrawerTitle")}
        size="lg"
        data-testid="new-etr-drawer"
      >
        <CreateEtrForm
          childId={childId}
          onCreated={() => {
            setShowCreateEtr(false);
            reloadEtrs();
          }}
          onCancel={() => setShowCreateEtr(false)}
        />
      </Drawer>
    </Card>
  );
}
